/**
 * This is dashboard script.js file
 */


export default {
    name: 'Dashboard',

    components: {

    },

    data: () => ({

    }),

    methods: {

    },

    computed: {

    }

};
